import palette from '../palette'

const colors = {
  ...palette,

  while: palette.white,
  black: palette.black,

  text: {
    title: palette.cetaceanBlue,
    body: palette.charcoal,
    muted: palette.rhythm,
    invertedBody: `${palette.white}cc`,
    invertedMuted: `${palette.white}88`,
    invertedTitle: palette.white,
    link: palette.celticBlue,
    linkHover: palette.sapphire,
    linkDisabled: palette.vistaBlue,
  },

  surface: {
    screen: palette.lotion,
    block: palette.white,
    field: palette.white,
    inverted: palette.cetaceanBlue,
    subtle: palette.brightGray,
  },

  border: {
    default: palette.manatee,
    strong: palette.blackCoral,
    slight: palette.lightPeriwinkle,
    invertedSlight: palette.independence,
    invertedDefault: palette.onyx,
  },

  success: {
    default: palette.yellowGreen,
  },

  danger: {
    default: palette.venetianRed,
  },

  button: {
    primary: {
      default: {
        text: palette.charcoal,
        background: 'transparent',
        border: palette.lavenderGray,
      },
      hover: {
        text: palette.cetaceanBlue,
        background: 'transparent',
        border: palette.blackCoral,
      },
      disabled: {
        text: palette.rhythm,
        background: 'transparent',
        border: palette.manatee,
      },
    },
  },

  // legacy
  primary: palette.deepCove,
  secondary: palette.softPeach,
  error: palette.burntSienna,
  font: {
    primary: palette.deepCove,
    secondary: palette.white,
    link: palette.deepCove,
    linkLight: palette.royalBlue,
    light: palette.roseBud,
    placeholder: palette.ghost,
  },
  bg: {
    default: palette.white,
    primary: palette.deepCove,
    secondary: palette.softPeach,
    tertiary: palette.ghostWhite,
    light: palette.roseBud,
    almond: palette.almondLight,
    overlay: `${palette.deepCove}80`,
  },
  calculator: {
    action: palette.actionBlue,
    actionHover: palette.ultramarine,
    selected: palette.actionWhite,
    secondary: palette.lamantin,
    border: palette.cryola,
    light: palette.ghostWhite,
    dot: palette.lavanda,
    borderAlt: palette.ghostWhiteAlt,
    textSecondary: palette.deepBlue,
    backgroundOpacity: palette.signalBlackOpacity,
  },
}

export default colors
